import React, { useContext, useEffect, useState, type FC } from "react";
import { Route, Routes } from "react-router-dom";

import MainLayout from "./Layout/MainLayout";

import {
  Landing,
  AboutUs,
  Rules,
  Blog,
  Post,
  Gallery,
  Album,
  Cart,
  ContactUs,
  Profile,
  NotFound,
  MyRules,
  MyEvents,
  Event,
  Events,
  Coachs,
  Coach,
  CoachRegister,
  PaymentHistory,
  CoachInformationPage,
  CoachStudentsPage,
  ResponsibleStudentPage,
  MyInformationPage,
  CoachPlansPage,
  ChangePassword,
  ImpersonatePage
} from "../Pages";
import { LoadingContext } from "../Context";
import ProfileContext from "../Context/ProfileContext";
import { TransactionGetProfile } from "../Services/Transactions";
import { ProfileType, UserTypeEnum } from "../Structures";

const Authenticated: FC = () => {
  const { setLoading } = useContext(LoadingContext);

  // ==============================================================

  const [profile, setProfile] = useState<ProfileType>({
    user_type: UserTypeEnum.USER,
    phoneNumber: "",
    first_name: "",
    last_name: "",
    fatherName: null,
    nationalCode: null,
    city: null,
    gender: null,
    birthDay: null,
    profile: null,
    personalVerification: true,
    coach: null,
    verified_by_coach: false,
    verified_by_responsible: false,
    document: {
      federationMembershipCard: null,
      insuranceCard: null,
    },
  });

  // ==============================================================

  const getProfile = () => {
    setLoading(true);
    TransactionGetProfile()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setProfile(res.data!);
        }
      })
      .finally(() => setLoading(false));
  };

  const setPersonalVerification = (value: boolean) => {
    setProfile({ ...profile, personalVerification: value });
  };

  // ==============================================================

  useEffect(() => {
    getProfile();
  }, []);

  // ================================================================

  return (
    <ProfileContext.Provider
      value={{ profile, setProfile, setPersonalVerification, getProfile }}
    >
      <MainLayout>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/rules" element={<Rules />} />
          
          <Route path="/impersonate" element={<ImpersonatePage />} />

          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id/" element={<Post />} />

          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallery/:id/" element={<Album />} />

          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />

          <Route path="/events" element={<Events />} />
          <Route path="/events/:id/" element={<Event />} />

          <Route path="/coachs" element={<Coachs />} />
          <Route path="/coachs/:id/" element={<Coach />} />

          <Route path="*" element={<NotFound />} />

          {/* ============================================== */}

          <Route path="/cart" element={<Cart />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/my-rules" element={<MyRules />} />
          <Route path="/my-events" element={<MyEvents />} />
          <Route path="/payment-history" element={<PaymentHistory />} />
          <Route path="/coach-register" element={<CoachRegister />} />

          <Route path="/my-information" element={<MyInformationPage />} />
          <Route path="/my-members" element={<CoachStudentsPage />} />
          <Route path="/coach-plans" element={<CoachPlansPage />} />
          <Route path="/coach-information" element={<CoachInformationPage />} />
          <Route
            path="/responsible-students"
            element={<ResponsibleStudentPage />}
          />
        </Routes>
      </MainLayout>
    </ProfileContext.Provider>
  );
};

export default Authenticated;
